
import { SET_SOCKET } from './_CONSTANTS';

export const setSocket = (socket) => {
  return {
    type: SET_SOCKET,
    payload: socket
  };
};